import { Filter as FilterBackboneModel } from 'aqTypes';
import { type ColorFilterDescriptor } from './computeConditionalFormatting';

export const toColorFilterDescriptor = (
  filter: FilterBackboneModel
): ColorFilterDescriptor => ({
  version: filter.get('version'),
  color: filter.get('color'),
  value: filter.get('value'),
  type: filter.get('type'),
  comparator: filter.get('comparator'),
  name: filter.get('name'),
  affectsTypeName: filter.get('affectsTypeName'),
  affectsTypeNames: filter.get('affectsTypeNames'),
});
